import { motion } from "framer-motion";

const stats = [
  {
    figure: "26%",
    text: "of restaurant operators are already using AI-related tools in their restaurants.",
  },
  {
    figure: "6 in 10",
    text: "millennials and Gen Z adults say they'd be comfortable placing an order with an AI-generated bot.",
    prefix: "roughly",
  },
];

const Stats = () => {
  return (
    <section className="relative py-24 md:py-32 border-t border-line" data-testid="stats-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mb-14 md:mb-20"
        >
          <span className="text-terra font-heading text-sm font-semibold tracking-widest uppercase">The shift is already here</span>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-cream">
            AI ordering isn't coming to restaurants. It's already mainstream, and accelerating.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {stats.map((s, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="border border-line bg-surface p-8 md:p-10"
              data-testid={`stat-card-${i}`}
            >
              <div className="font-heading text-6xl sm:text-7xl md:text-8xl font-bold tracking-tighter text-terra leading-none">
                {s.prefix && <span className="block font-sans text-sm md:text-base font-semibold uppercase tracking-widest text-cream mb-3">{s.prefix}</span>}
                {s.figure}
              </div>
              <p className="mt-6 text-base sm:text-lg text-sand leading-relaxed max-w-md">{s.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="mt-10 text-sm text-sand/70 max-w-2xl"
          data-testid="stats-source"
        >
          Source: National Restaurant Association's 2026 State of the Restaurant Industry report.
        </motion.p>
      </div>
    </section>
  );
};

export default Stats;
